import * as i0 from '@angular/core';
import { input, model, viewChild, signal, computed, output, Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxTooltipDirective } from '@digipay/ngx-tooltip';
import { NgClass, NgStyle } from '@angular/common';
import * as i1 from '@digipay/ngx-badge';
import { NgxBadgeModule } from '@digipay/ngx-badge';
import { NgxIcon } from '@digipay/ngx-icon';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
const _c0 = ["switchOptions"];
const _c1 = a0 => ({
  hidden: a0
});
const _c2 = (a0, a1) => ({
  "selected": a0,
  "disabled": a1
});
function NgxSegmentedControlComponent_For_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-icon", 6);
  }
  if (rf & 2) {
    let tmp_12_0;
    const option_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("type", (tmp_12_0 = option_r4.iconType) !== null && tmp_12_0 !== undefined ? tmp_12_0 : "bold")("name", option_r4.icon);
  }
}
function NgxSegmentedControlComponent_For_5_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ngx-badge", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("mode", option_r4.disable ? "bold" : ctx_r2.countStatus())("status", option_r4.disable ? "inactive" : "info");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r4.count, " ");
  }
}
function NgxSegmentedControlComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 5);
    i0.ɵɵlistener("click", function NgxSegmentedControlComponent_For_5_Template_li_click_0_listener($event) {
      const i_r2 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.optionClick(i_r2, $event));
    });
    i0.ɵɵtemplate(1, NgxSegmentedControlComponent_For_5_Conditional_1_Template, 1, 2, "ngx-icon", 6);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, NgxSegmentedControlComponent_For_5_Conditional_3_Template, 2, 3, "ngx-badge", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("option d-flex align-items-center justify-content-center fs-12 cursor-pointer text-align-center fw-bold px-pony gap-tiny\n ", option_r4.disable ? "text-onback-disabled" : ctx_r2.selectedOption() && ctx_r2.selectedOption().id === option_r4.id ? "text-onback-high" : "text-onback-low", "");
    i0.ɵɵstyleProp("width", ctx_r2.segmentItemWidth());
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c2, ctx_r2.selectedOption() && ctx_r2.selectedOption().id === option_r4.id, option_r4.disable));
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, (option_r4 == null ? null : option_r4.icon) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r4.text, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(3, (option_r4 == null ? null : option_r4.count) && (option_r4 == null ? null : option_r4.count) >= 0 ? 3 : -1);
  }
}
let NgxSegmentedControlComponent = /*#__PURE__*/(() => {
  class NgxSegmentedControlComponent {
    constructor() {
      this.countStatus = input('fill');
      this.options = input();
      this.mode = input('PAGE_SEGMENT');
      this.selectedOption = model(null);
      this.switchOptionsRef = viewChild('switchOptions');
      this.highlightLeft = signal(0);
      this.styles = computed(() => {
        return {
          width: 100 / this.options().length + '%'
        };
      });
      this.highlightLeftPosition = computed(() => this.highlightLeft() + 'px');
      this.segmentItemWidth = computed(() => 100 / this.options().length + '%');
      this.change = output();
      toObservable(this.options).pipe(takeUntilDestroyed()).subscribe(() => {
        if (this.switchOptionsRef()) {
          this.calcHighlighterOffset();
        }
      });
    }
    ngAfterViewChecked() {
      this.calcHighlighterOffset();
    }
    calcHighlighterOffset() {
      if (!this.switchOptionsRef() || !this.selectedOption()) {
        return;
      }
      let index;
      index = this.options().findIndex(item => item.id === this.selectedOption().id);
      if (index < 0) {
        const lastIndex = this.options().length - 1;
        this.selectedOption.set(this.options()[lastIndex]);
      }
      const el = this.switchOptionsRef().nativeElement.children.item(index);
      this.highlightLeft.set(el?.offsetLeft);
    }
    optionClick(index, event) {
      this.highlightLeft.set(event.target.offsetLeft);
      this.selectedOption.set(this.options()[index]);
      this.change.emit(this.selectedOption());
    }
    static {
      this.ɵfac = function NgxSegmentedControlComponent_Factory(t) {
        return new (t || NgxSegmentedControlComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxSegmentedControlComponent,
        selectors: [["ngx-segmented-control"]],
        viewQuery: function NgxSegmentedControlComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.switchOptionsRef, _c0, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          countStatus: [i0.ɵɵInputFlags.SignalBased, "countStatus"],
          options: [i0.ɵɵInputFlags.SignalBased, "options"],
          mode: [i0.ɵɵInputFlags.SignalBased, "mode"],
          selectedOption: [i0.ɵɵInputFlags.SignalBased, "selectedOption"]
        },
        outputs: {
          selectedOption: "selectedOptionChange",
          change: "change"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 7,
        vars: 12,
        consts: [["switchOptions", ""], [1, "segment-container"], [1, "switch-options", "p-atom", "m-atom", "w-100", "d-flex"], [3, "ngClass", "width", "class"], [3, "ngClass", "ngStyle"], [3, "click", "ngClass"], [1, "icon", 3, "type", "name"], ["size", "sm", "type", "count", 3, "mode", "status"]],
        template: function NgxSegmentedControlComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "div")(2, "ul", 2, 0);
            i0.ɵɵrepeaterCreate(4, NgxSegmentedControlComponent_For_5_Template, 4, 12, "li", 3, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelement(6, "li", 4);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("switch p-tiny radius-small ", ctx.mode() === "PAGE_SEGMENT" ? "switch-page-segment" : "switch-section-segment", "");
            i0.ɵɵadvance(3);
            i0.ɵɵrepeater(ctx.options());
            i0.ɵɵadvance(2);
            i0.ɵɵclassMapInterpolate1("", ctx.mode() === "PAGE_SEGMENT" ? "page-segment" : "section-segment", " selected-option-highlight radius-small h-100");
            i0.ɵɵstyleProp("left", ctx.highlightLeftPosition());
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1, !ctx.selectedOption()))("ngStyle", ctx.styles());
          }
        },
        dependencies: [NgClass, NgStyle, NgxBadgeModule, i1.NgxBadgeComponent, NgxIcon],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}.segment-container[_ngcontent-%COMP%]   .switch[_ngcontent-%COMP%]{direction:rtl}.segment-container[_ngcontent-%COMP%]   .switch[_ngcontent-%COMP%]   .switch-options[_ngcontent-%COMP%]{position:relative;list-style:none}.segment-container[_ngcontent-%COMP%]   .switch[_ngcontent-%COMP%]   .switch-options[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]{flex-grow:1;flex-shrink:1;position:relative;z-index:1;min-height:32px}.segment-container[_ngcontent-%COMP%]   .switch[_ngcontent-%COMP%]   .switch-options[_ngcontent-%COMP%]   .option.disabled[_ngcontent-%COMP%]{pointer-events:none}.segment-container[_ngcontent-%COMP%]   .switch[_ngcontent-%COMP%]   .switch-options[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]   .icon-container[_ngcontent-%COMP%]{width:20px;height:20px}.segment-container[_ngcontent-%COMP%]   .switch[_ngcontent-%COMP%]   .selected-option-highlight[_ngcontent-%COMP%]{position:absolute;top:0;left:0;z-index:0;transition:left .6s cubic-bezier(.02,.94,.09,.97),background .3s cubic-bezier(.17,.67,.14,1.03);box-sizing:border-box}.segment-container[_ngcontent-%COMP%]   .switch[_ngcontent-%COMP%]   .selected-option-highlight.hidden[_ngcontent-%COMP%]{visibility:hidden}.segment-container[_ngcontent-%COMP%]   .switch[_ngcontent-%COMP%]   .section-segment[_ngcontent-%COMP%]{background:var(--surface-elevated)}.segment-container[_ngcontent-%COMP%]   .switch[_ngcontent-%COMP%]   .page-segment[_ngcontent-%COMP%], .segment-container[_ngcontent-%COMP%]   .switch-section-segment[_ngcontent-%COMP%]{background:var(--onback-shade-95)}.segment-container[_ngcontent-%COMP%]   .switch-page-segment[_ngcontent-%COMP%]{background-color:var(--surface-elevated)}"],
        changeDetection: 0
      });
    }
  }
  return NgxSegmentedControlComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-segmented-control
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxSegmentedControlComponent };
